import _ from "lodash";
import React,{ Component } from "react";
import { Link } from "react-router-dom";
import {connect} from "react-redux";
import { getServers} from "../../../actions/actionServer";
import { Row, Col, Table, Card, CardBody, CardHeader, Button} from "reactstrap";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import moment from "moment";
import ReactJson from 'react-json-view';
import { Progress } from 'reactstrap';
import iconNo from "../../../../assets/images/icon_no.svg";
import iconYes from "../../../../assets/images/icon_yes.svg";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Agent",path:"/agents",isActive: false},
    {name: "ViewAgent",path:"/viewagent",isActive: true},
];

class ViewServer extends Component{
    constructor(props){
        super(props);
        this.state = {
            currentServer: null
        };
    }
  
    componentDidMount(){
        this.props.getServers();
    }
      
    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.servers.length > 0){        	
            let currentServer = nextProps.servers.find(server => server.server_id === this.props.match.params.id);
            this.setState({currentServer: currentServer});
        }
    }

    formatSizeUnits(bytes){
      if      (bytes >= 1073741824) { bytes = (bytes / 1073741824).toFixed(2) + " GB"; }
      else if (bytes >= 1048576)    { bytes = (bytes / 1048576).toFixed(2) + " MB"; }
      else if (bytes >= 1024)       { bytes = (bytes / 1024).toFixed(2) + " KB"; }
      else if (bytes > 1)           { bytes = bytes + " bytes"; }
      else if (bytes == 1)          { bytes = bytes + " byte"; }
      else                          { bytes = "0 bytes"; }
      return bytes;
    }

    renderGPUStats() {
        const { currentServer } = this.state;

        if (!currentServer || !currentServer.gpus || !currentServer.gpu_info) {
            return null;
        }

        const gpus = _(currentServer.gpu_info)
            .map((details, id) => ({
                id,
                model: details.model,
                vendor: details.vendor,
                gpuTemperature: currentServer.gpu_temp[id],
                gpuUsage: currentServer.gpu_percent[id],
                gpuMemoryUsage: currentServer.gpu_memory_used_percent[id]
            }))
            .sortBy("id")
            .value();

        return _.map(gpus, (details, index) =>
            <div className="agent-padding gpu-info" key={index}>
                <div>
                    <span className="gpu-name">GPU {index} - {details.model}</span>
                    <span className="gpu-id">({details.id})</span>
                </div>
                <div className="field">GPU Utilization: <b>{_.round(details.gpuUsage, 2)}%</b></div>
                <Progress
                    striped
                    color={details.gpuUsage > 80 ? "danger" : "success"}
                    value={details.gpuUsage} />
                <div className="field">Memory Utilization: <b>{_.round(details.gpuMemoryUsage, 2)}%</b></div>
                <Progress
                    striped
                    color={details.gpuMemoryUsage > 80 ? "danger" : "success"}
                    value={details.gpuMemoryUsage} />
                <div className="field">GPU Temperature: <b>{_.round(details.gpuTemperature, 2)}°</b></div>
                <Progress
                    striped
                    color={details.gpuTemperature > 70 ? "danger" : "success"}
                    value={details.gpuTemperature} />
            </div>
        );
    }

    render(){
        const {currentServer} = this.state;
        return (
            <div className="profile-page">  
                <BreadCrumbCompo routes={routes}/>    
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                               <strong>View Server</strong>
                                {currentServer ? <Link className="pull-right" to={{ pathname: `/update_server/${currentServer.server_id}`}}>
                                    <Button size="sm" 
                                    className = "reset-btn"
                                    color="primary"> Edit </Button> </Link> : " " }
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">
                                        <div className="profile-table">
                                            {currentServer?
                                                <Table >
                                                    <tbody>
                                                       <tr><td><h4>ID</h4></td><td>{currentServer.server_id}</td></tr>
                                                       <tr><td><h4>Hostname</h4></td><td>{currentServer.hostname}</td></tr>
                                                       <tr><td><h4>Friendly Name</h4></td><td>{currentServer.friendly_name}</td></tr>
                                                       <tr><td><h4>Enabled</h4></td><td><img src={currentServer.enabled? iconYes: iconNo} alt="yesnoIcon" /></td></tr>
                                                       <tr><td><h4>Connection Type</h4></td><td>{currentServer.connection_type}</td></tr>
                                                       <tr><td><h4>Connection Port</h4></td><td>{currentServer.connection_port}</td></tr>
                                                       <tr><td><h4>Connection Username</h4></td><td>{currentServer.connection_username}</td></tr>
                                                       <tr><td><h4>Connection Password</h4></td><td>{currentServer.connection_password ? "********" : "--"}</td></tr>
                                                       <tr><td><h4>Connection Info</h4></td><td className="word-wrap">
                                                            <ReactJson src={currentServer.connection_info }
                                                                name={false}
                                                                collapsed={false}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                            />
                                                        </td></tr>
                                                       <tr><td><h4>Max Simultaneous Sessions </h4></td><td>{currentServer.max_simultaneous_sessions}</td></tr>
                                                       <tr><td><h4>Zone</h4></td><td>{currentServer.zone_name}</td></tr>
                                                       <tr><td><h4>Pool</h4></td><td>{currentServer.server_pool_name ? currentServer.server_pool_name : "--"}</td></tr>
                                                    </tbody>
                                                </Table> :" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );}
}

ViewServer.propTypes = {
    getServers: Proptypes.func.isRequired,
    servers: Proptypes.array,
    match: Proptypes.object,
};

export default connect(state => 
    ({
        servers: state.servers.servers || []
    }),
dispatch => 
    ({  
        getServers: () => dispatch(getServers()),
    }))(ViewServer);
